import store from "@/store/index";
import router from "@/router/index";

export function GetBaseMetaData() {
  let meta_data_list = store.state.page_meta_data;
  return {
    title: meta_data_list[0].Title,
    content: meta_data_list[0].Content,
    image: GetImageUrl(meta_data_list[0].Image),
  };
}

export function GetMetaData(title, content = "", image = "") {
  // let meta_data = GetMatchMetaData();
  const base_meta = GetBaseMetaData();
  let meta_data = {
    title: "首頁",
    content: base_meta.content,
    image: base_meta.image,
  };
  title != "" ? (meta_data.title = title) : "";
  content != "" ? (meta_data.content = content) : "";
  image != "" ? (meta_data.image = image) : "";

  if (meta_data.image == "") {
    meta_data.image = "/img/share.png";
  }
  meta_data.content.length > 155
    ? (meta_data.content = meta_data.content.slice(0, 155) + "...")
    : "";

  return {
    title: meta_data.title + base_meta.title,
    meta: [
      {
        property: "og:url",
        name: "og:url",
        content: process.env.VUE_APP_BASEURL + router.history.current.fullPath,
        vmid: "og:url",
      },
      {
        property: "og:title",
        name: "og:title",
        content: meta_data.title,
        vmid: "og:title",
      },
      {
        property: "og:description",
        name: "og:description",
        content: meta_data.content,
        vmid: "og:description",
      },
      {
        property: "twitter:description",
        name: "twitter:description",
        content: meta_data.content,
        vmid: "twitter:description",
      },
      {
        property: "description",
        name: "description",
        content: meta_data.content,
        vmid: "description",
      },
      {
        property: "og:image",
        name: "og:image",
        content: meta_data.image,
        vmid: "og:image",
      },
      {
        property: "apple-mobile-web-app-title",
        name: "apple-mobile-web-app-title",
        content: meta_data.title,
        vmid: "apple-mobile-web-app-title",
      },
      {
        property: "application-name",
        name: "application-name",
        content: meta_data.title,
        vmid: "application-name",
      },
      {
        property: "og:site_name",
        name: "og:site_name",
        content: "官方網站",
        vmid: "og:site_name",
      },
      {
        property: "og:type",
        name: "og:type",
        content: "website",
        vmid: "og:type",
      },
      {
        property: "og:locale",
        name: "og:locale",
        content: "zh_tw",
        vmid: "og:locale",
      },
    ],
  };
}

function GetImageUrl(item) {
  return item == "" ? "" : process.env.VUE_APP_BASE_API + item;
}
